import { LoadTextures } from '../../../../vendors/ngab/load/LoadTextures';
import { FONTS } from '../../../constants/fonts';
import { convertArrayToObject } from '../../../helpers/array';
import fontAtlasRegular from '../../../../assets/fonts/Roboto-Regular.png';
import fontAtlasBlack from '../../../../assets/fonts/Roboto-Black.png';
import fontFileRegular from '../../../../assets/fonts/Roboto-Regular.fnt';
import fontFileBlack from '../../../../assets/fonts/Roboto-Black.fnt';

const loadFont = require('load-bmfont');

const fonts = {
    map: new Map(),
    loaded: false
};

const loadFnt = (url) => new Promise((resolve, reject) => {
    loadFont(url, (err, font) => {
        if (font && !err) resolve(font);
        else reject(err);
    });
});

const loadFntArray = async (items) => {
    const result = {};
    let err = null;

    await Promise.all(items.map((item) => loadFnt(item.url).then((font) => {
        result[item.id || item.name] = font;
    }).catch(() => {
        err = `Font ${item.id || item.name} path ${item.url} failed`;
        // eslint-disable-next-line no-console
        console.warn(err);
    })));

    if (err) return { error: err, result };

    return result;
};

export const FontsStorage = {
    async loadBMFs(progressUpdate) {
        if (fonts.loaded) return fonts.map;

        const fontFiles = [
            {
                name: FONTS.REGULAR,
                url: fontFileRegular,
                fontSizeFix: 1
            },
            {
                name: FONTS.ACCENT,
                url: fontFileBlack,
                fontSizeFix: 1 // e.g. 120 / 70
            }
        ];
        const fontAtlases = [
            {
                name: FONTS.REGULAR,
                url: fontAtlasRegular
            },
            {
                name: FONTS.ACCENT,
                url: fontAtlasBlack
            }
        ];

        let atlases = null;
        let fnts = null;
        const fontFilesMap = convertArrayToObject(fontFiles, 'name');

        try {
            atlases = await LoadTextures(fontAtlases, true, true, progressUpdate, false);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('Atlas loading failed', e);
        }

        try {
            fnts = await loadFntArray(fontFiles);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('Fonts loading failed');
        }

        if (!fnts || fnts.error) throw new Error(fnts ? fnts.error : 'Fonts loading failed. No font object available');

        const fontFamilies = Object.keys(fnts);

        fontFamilies.forEach((family) => {
            const font = fnts[family];
            const atlas = atlases[family];

            if (!font || !atlas) return;

            const { fontSizeFix } = fontFilesMap[family];

            fonts.map.set(family, {
                font,
                atlas: atlas.texture,
                fontSizeFix
            });
        });

        return fonts.map;
    },

    get(familyName) {
        if (fonts.map.has(familyName)) return fonts.map.get(familyName);

        return null;
    }
};
